import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import LogicTemplateLibraryIcon from "../../assets/icons/library_logic.svg2";
import LibraryLinks from "./LibraryLinks";
import PageHeader from "../Common/PageHeader";
import MyBadge from "../Common/MyBadge";
import MyPagination from "../Common/MyPagination";
import WhiteButton from "../Common/WhiteButton";
import LibraryIcon from "../../assets/icons/library_puzzle.svg2";
import Subheading from "../Common/Subheading";
import ComponentDetails from "./ComponentDetails";
import MyTemplateCard from "./MyTemplateCard";
import ComponentCard from "./ComponentCard";
import ProjectImportModal from "../Builder/Components/ProjectImportModal";
import ComponentLibraryFilter from "./ComponentLibraryFilter";
import { useNavigate } from "react-router-dom";
import ContactsIcon from "../../assets/icons/contact_edit.svg2";
import { useListProjectQuery } from "../store/slices/settingsSlice";
import HelpButton from "../HelpContent/HelpButton";
import WhiteButtonDropdown from "../Common/WhiteButtonDropdown";

export default function LogicTemplateLibrary({ isModal }) {
  const navigate = useNavigate();
  const [selectedTemplate, setSelectedTemplate] = useState();
  const [filters, setFilters] = useState({
    offset: 0,
    limit: 12,
    status: ["production", "draft"],
    order: "created",
    label: "",
    solutionFilter: "any",
    direction: "desc",
  });

  const { data: projectsData } = useListProjectQuery(filters);
  useEffect(() => {
    if (
      (!selectedTemplate ||
        !projectsData?.projects?.some(
          (p) => p.UUID === selectedTemplate?.UUID
        )) &&
      projectsData?.projects?.length > 0
    ) {
      setSelectedTemplate(projectsData.projects[0]);
    }
    if (projectsData?.projects?.length === 0) {
      setSelectedTemplate(null);
    }
  }, [projectsData]);

  const projects = projectsData?.projects || [];
  const total = projectsData?.total || 0;

  return (
    <div>
      <div className="">
        <div className="d-flex align-items-center justify-content-between mb-2">
          <Subheading
            Icon={LogicTemplateLibraryIcon}
            heading="Logic Component"
            subheading="Access your Logic Components."
          />
          <div>
            <WhiteButtonDropdown
              toggleHeading={"Actions"}
              toggleSubheading={"Logic Component"}
            >
              <WhiteButton
                as="RRLink"
                icon={ContactsIcon}
                to="/library/logic/builder/new/settings"
                heading="Component"
                subheading="Create"
              />
              <WhiteButton
                as="RRLink"
                icon={ContactsIcon}
                to="/reporting/processes"
                heading="Processes "
                subheading="Manage"
              />
              <WhiteButton
                as="RRLink"
                icon={ContactsIcon}
                to="/inbounds"
                heading="Inbounds "
                subheading="Manage"
              />
              <ProjectImportModal />
            </WhiteButtonDropdown>
          </div>
        </div>
        <ComponentLibraryFilter filters={filters} setFilters={setFilters} />

        <Row className="mb-5 my-3 w-100">
          <Col lg={4} className="pe-5 border-end border-2">
            <div
              style={{
                maxHeight: 500,
                overflowY: "auto",
                scrollbarColor: "purple",
              }}
              className="pe-2 fw-bold"
            >
              <div className="align-items-center">
                <span className="fs-3">
                  {" "}
                  Component Results
                  <HelpButton helpKey="component-results" />
                </span>
                <MyBadge count={total} />{" "}
              </div>
              {projects.map((project) => (
                <div
                  key={project.UUID}
                  onDoubleClick={() => {
                    navigate(`/library/logic/builder/${project.ID}`);
                  }}
                >
                  <MyTemplateCard
                    isSelected={selectedTemplate?.UUID === project.UUID}
                    onSelect={() => setSelectedTemplate(project)}
                  >
                    <ComponentCard project={project} />
                    {project.IsSingleton && (
                      <span
                        title="Allow only one instace running"
                        className="badge bg-danger rounded-circle ms-n5"
                      >
                        1
                      </span>
                    )}
                  </MyTemplateCard>
                </div>
              ))}
            </div>
            <div className="mt-3">
              <MyPagination
                total={total}
                onPaginate={(page, perPage) => {
                  setFilters((prev) => ({
                    ...prev,
                    offset: page * perPage,
                    limit: perPage,
                  }));
                }}
              />
            </div>
          </Col>
          <Col className="ps-5" lg={7}>
            {selectedTemplate ? (
              <>
                About this component:
                <ComponentDetails project={selectedTemplate} />
              </>
            ) : (
              <div className="p-5 text-center fs-2">Nothing is selected.</div>
            )}
          </Col>
        </Row>
      </div>
    </div>
  );
}
